var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrevious(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8398 13.25C19.8398 13.7422 19.4531 14.1289 18.9961 14.1289H7.04297L11.7188 18.5586C12.0703 18.875 12.0703 19.4375 11.7539 19.7539C11.4375 20.1055 10.9102 20.1055 10.5586 19.7891L4.37109 13.8828C4.19531 13.707 4.125 13.4961 4.125 13.25C4.125 13.0391 4.19531 12.8281 4.37109 12.6523L10.5586 6.74609C10.9102 6.42969 11.4375 6.42969 11.7539 6.78125C12.0703 7.09766 12.0703 7.66016 11.7188 7.97656L7.04297 12.4062H18.9961C19.4883 12.4062 19.8398 12.793 19.8398 13.25Z",
    fill: "#0D3338"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrevious);
export default __webpack_public_path__ + "static/media/Previous.1a35702f02180f52e2f53195ee88a6ee.svg";
export { ForwardRef as ReactComponent };